import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/audit', () => {
    return HttpResponse.json({ items: [], nextCursor: null });
  }),
];

export default handlers;
